import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import EditIcon from "@mui/icons-material/Edit";
import {
  Checkbox,
  FormControlLabel,
  Switch,
  useMediaQuery,
  Chip,
  debounce,
  InputAdornment,
} from "@mui/material";
import { Autocomplete, TextField } from "@mui/material";
import { axiosInstance } from "../utility/apiInstance";
import { useNavigate } from "react-router-dom";
import {
  GridRowsProp,
  GridRowModesModel,
  GridRowModes,
  DataGrid,
  GridColDef,
  GridToolbarContainer,
  GridActionsCellItem,
  GridEventListener,
  GridRowId,
  GridRowModel,
  GridRowEditStopReasons,
  GridSlots,
  GridToolbarProps,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
// import { randomId } from "@mui/x-data-grid-generator";

import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import toast from "react-hot-toast";
import {
  hideToggleButton,
  hideToggleButtonEditMode,
  preventAddingDuplocateRow,
} from "../utility/constant";
import clsx from 'clsx';
import TeamDrawer from "./TeamDrawer";
import SearchInput from "../common/SearchInput";
import { CustomLoadingOverlay, CustomNoRowsOverlay } from "../common/Datagridoverlays";
import { FOOTER_HEIGHT, HEADER_HEIGHT, MAX_GRID_HEIGHT, ROW_ESTIMATE } from "./Contants/constantValue";

const MIN_GRID_HEIGHT = 400;
function randomId() {
  return Math.random().toString(36).substr(2, 9);
}

const id = randomId();

interface EditToolbarProps extends GridToolbarProps {
  setRows: (newRows: (oldRows: GridRowsProp) => GridRowsProp) => void;
  setRowModesModel: (
    newModel: (oldModel: GridRowModesModel) => GridRowModesModel
  ) => void;
  currentPage: number;
  isAddDisabled: boolean;
  setIsAddDisabled: React.Dispatch<React.SetStateAction<boolean>>;
}


export default function ManageTeamCustomerTable() {
  const isBigScreen = useMediaQuery("(min-width:1800px)");
  const is1366 = useMediaQuery("(max-width:1366px)");
  const navigate = useNavigate();
  const [rows, setRows] = React.useState<any>([]);
  const [userId, setUserId] = React.useState<any>(null);
  const [CustomerList, setAllCustomer] = React.useState<any>();
  const [searchQuery, setSearchQuery] = React.useState<string>("");
  const [rowdata, setRowdata] = React.useState([]);
  const [currentPage, setCurrentPage] = React.useState(0);
  const [loading, setLoading] = React.useState(false);
  const [rowModesModel, setRowModesModel] = React.useState<GridRowModesModel>(
    {}
  );
  const [isAddDisabled, setIsAddDisabled] = React.useState(false);
  const [isOpen, setIsOpen] = React.useState<boolean>(false)

  const handleLogout = (): void => {
    localStorage.clear();
    navigate("/");
  };

  function EditToolbar(props: EditToolbarProps) {

    const {
      setRows,
      setRowModesModel,
      currentPage,
      isAddDisabled,
      setIsAddDisabled,
    } = props;

    const handleClick = () => {
      const id = Math.random();
      setRows((oldRows) => {
        if (!preventAddingDuplocateRow(oldRows)) {
          toast.error("You can only submit one record at a time!");
          return oldRows;
        }

        setIsAddDisabled(true);

        setRowModesModel((oldModel) => ({
          ...oldModel,
          [id]: { mode: GridRowModes.Edit, fieldToFocus: "teamName" },
        }));

        return [
          {
            id,
            teamName: "",
            description: "",
            teamMembers: [],
            isActive: true,
            isNew: true,
            ishideToggle: false,
          },
          ...oldRows,
        ];
      });
    };


    return currentPage === 0 && (

      <GridToolbarContainer className="flex flex-wrap items-center justify-between gap-2 w-full">


        <TeamDrawer
          open={isOpen}
          CustomerList={CustomerList}
          userId={userId}
          onClose={() => { setUserId(null); setIsOpen(false); }}
        />

      </GridToolbarContainer>
    )
  }

  const getAllCustomerTeam = async () => {
    setLoading(true);
    try {
      let response
      response = await axiosInstance.get("/api/v1/customer-team");


      const fetchedRows = response?.data?.data?.reverse();
      const data = fetchedRows.map((row: any, index: any) => ({
        ...row,
        key: row?._id || row?.id,
        id: row?._id || row?.id,
        ishideToggle: true,
        isNew: false,
      }));
      setRows(data);
      if (response.data.statusCode === 401) {
        handleLogout();
      }
    } catch (err: any) {
      setRows([])
    } finally {
      setLoading(false);
    }
  };
  React.useEffect(() => {
    getAllCustomerTeam();
  }, []);
  const handleRowEditStop: GridEventListener<"rowEditStop"> = (
    params,
    event
  ) => {
    if (params.reason === GridRowEditStopReasons.rowFocusOut) {
      event.defaultMuiPrevented = true;
    }
  };

  const handleEditClick = (id: GridRowId) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
    setIsAddDisabled(true);
  };

  const handleSaveClick = (id: GridRowId) => async () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });

    setRows((prev: any) => {
      let array = [...prev];
      let findIndex = array.findIndex((item: any) => item?._id === id);
      if (findIndex !== -1) {
        array[findIndex].ishideToggle = false;
      }
      return array;
    });

    setIsAddDisabled(false);
  };

  const debouncedHandleDeleteClick = debounce(
    async (id: GridRowId, row: any) => {
      const updatedIsDeleted = !row.isDeleted;
      const payload = { isDeleted: updatedIsDeleted };
      const url = `/api/v1/customer-team/${id}`;

      try {
        const response = await axiosInstance.delete(url, {
          data: payload,
        });

        if (response.status !== 200) {
          toast.error("Error updating customer team status.");
        } else {
          const successMessage = updatedIsDeleted
            ? "Customer team deactivated successfully."
            : "Customer team activated successfully.";
          toast.success(successMessage);
          getAllCustomerTeam();
        }
      } catch (error: any) {
        error?.response?.data?.error
          ? toast.error(error.response.data.error)
          : toast.error(
            "An error occurred while updating customer team status."
          );
      }
    },
    300
  );

  const handleDeleteClick = (id: GridRowId, row: any) => async () => {
    debouncedHandleDeleteClick(id, row);
  };

  const handleCancelClick = (id: GridRowId) => async () => {
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true },
    });

    const editedRow: any = rows.find((row: any) => row.id === id);
    if (editedRow?.isNew) {
      setRows(rows.filter((row: any) => row.id !== id));
    }

    if (!editedRow.isNew) {
      setRows((prev: any) => {
        let array = [...prev];
        let findIndex = array.findIndex((item: any) => item?._id === id);
        if (findIndex !== -1) {
          array[findIndex].ishideToggle = true;
        }
        return array;
      });
    }

    setIsAddDisabled(false);
  };

  const processRowUpdate = async (newRow: GridRowModel, params: any) => {
    const updatedRow: any = { ...newRow, isNew: false };
    setRowdata(updatedRow);
    const errors = [];
    if (!updatedRow.teamName) {
      errors.push("TeamName cannot be empty");
      setIsAddDisabled(true);
    }
    if (!updatedRow.description) {
      errors.push("Description cannot be empty");
      setIsAddDisabled(true);
    }
    if (!updatedRow.teamMembers) {
      errors.push("Organisation cannot be empty");
      setIsAddDisabled(true);
    }
    if (errors.length > 0) {
      if (
        updatedRow.id ===
        rows?.find((item: any) => item._id === updatedRow._id)?._id
      ) {
        setRows(hideToggleButton(rows, updatedRow.id));
      }

      errors.forEach((error) => toast.error(error));
      return;
    }

    if (+updatedRow.id < 1) {
      updatedRow.id = id;

      const formData = {
        teamName: updatedRow.teamName,
        description: updatedRow.description,
        teamMembers: updatedRow.teamMembers?.map((item: any) => item?._id),
      };
      try {
        const response = await axiosInstance.post(
          "/api/v1/customer-team",
          formData
        );
        const data = response.data;
        toast.success("Customer Team registered successfully");
        getAllCustomerTeam();
        setRows((prevRows: any) =>
          prevRows.map((row: any, index: number) =>
            row.id === newRow.id ? updatedRow : row
          )
        );
      } catch (err: any) {
        if (
          updatedRow.id ===
          rows?.find((item: any) => item._id === updatedRow._id)?._id
        ) {
          setRows(hideToggleButtonEditMode(rows, updatedRow));
        }

        Array?.isArray(err?.response?.data?.error)
          ? err?.response?.data?.error?.forEach((error: any) => {
            toast.error(`${error.field}: ${error.message}`);
          })
          : toast?.error(err.response.data.error) ||
          toast?.error("An error occurred during registration.");
        getAllCustomerTeam();
        return updatedRow;
      }
    } else {
      const sendData = {
        teamName: updatedRow.teamName,
        description: updatedRow.description,
        teamMembers: updatedRow.teamMembers?.map((item: any) => item?._id),
      };

      const url = `/api/v1/customer-team/${updatedRow._id}`;
      try {
        const response = await axiosInstance.put(url, sendData);
        const data = response.data;

        setRows((prev: any) => {
          let array = [...prev];
          let findIndex = array.findIndex(
            (item: any) => item?.id === response?.data?.data?._id
          );
          if (findIndex !== -1) {
            array[findIndex] = { ...array[findIndex], ...updatedRow };
          }
          return array;
        });

        toast.success(data?.message);
        getAllCustomerTeam();

        return updatedRow;
      } catch (err: any) {
        if (
          updatedRow.id ===
          rows?.find((item: any) => item._id === updatedRow._id)?._id
        ) {
          setRows(
            (prevRows: any) => hideToggleButtonEditMode(prevRows, updatedRow)
          );
        }

        if (Array.isArray(err.response?.data?.error)) {
          err.response.data.error.forEach((error: any) => {
            toast.error(`${error.field}: ${error.message}`);
          });
        } else {
          err.response?.data?.error
            ? toast.error(err.response?.data?.error)
            : toast.error("An error occurred during customer team update.");
        }
        setRows(
          (prevRows: any) => hideToggleButtonEditMode(prevRows, updatedRow)
        );
      }
    }
  };

  const handleRowModesModelChange = (newRowModesModel: GridRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };
  const handlePaginationChange = (paginationModel: any) => {
    setCurrentPage(paginationModel.page);
  };

  const getAllCustomer = async () => {
    try {
      const response = await axiosInstance.get(
        "/api/v1/customers-auth/team-member-list"
      );
      const allCustomerData = (response?.data?.data || []).filter((customer: any) => customer.role !== "groundstaff");
      setAllCustomer(allCustomerData);
      if (response.data.statusCode === 401) {
        handleLogout();
      }
    } catch (err: any) { }
  };
  React.useEffect(() => {
    getAllCustomer();
  }, []);




  React.useEffect(() => {
    if (!isOpen) {
      const timer = setTimeout(() => {
        getAllCustomerTeam();
      }, 500); // delay in ms

      return () => clearTimeout(timer);
    }
  }, [isOpen])

  const gridHeight = Math.min(
    MAX_GRID_HEIGHT,
    Math.max(
      MIN_GRID_HEIGHT,
      HEADER_HEIGHT + FOOTER_HEIGHT + Math.max(rows.length, 1) * ROW_ESTIMATE
    )
  );
  const columns: GridColDef[] = [
    {
      field: "s_no",
      headerName: "S.No.",
      //width: 70,
      width: is1366 ? 60 : 70,
      sortable: true,
      filterable: false,
      editable: false,
      disableColumnMenu: true,
    },
    {
      field: "teamName",
      headerName: "Team Name",
      //width: isMobile ? 200 : 250,
      //width: 250,
      width: is1366 ? 160 : 250,
      sortable: true,
      filterable: true,
      editable: false,
    },
    {
      field: "description",
      headerName: "Description",
      //width: isMobile ? 150 : 250,
      width: is1366 ? 240 : 350,
      sortable: true,
      filterable: true,
      editable: false,
      cellClassName: "new-row-border",
    },

    {
      field: "teamLeaders",
      headerName: "Team Leaders",
      // width: isMobile ? 220 : 450,
      //width: 450,
      width: is1366 ? 200 : 350,
      sortable: true,
      filterable: true,
      editable: false,
      renderCell: (params) => {
        const ids = params?.value || [];
        const idList = ids.map((item: any) => item._id);
        const names = CustomerList
          ?.filter((cust: any) => idList.includes(cust._id))
          ?.map((c: any) => c.name)
          ?.join(", ");

        return names || "-";
      },
      renderEditCell: (params) => (
        <Autocomplete
          multiple
          options={CustomerList || []}
          getOptionLabel={(option) => option.name}
          value={
            CustomerList?.filter((cust: any) =>
              params?.row?.teamLeaders
                ?.map((item: any) => item?._id)
                ?.includes(cust._id)
            ) || []
          }
          onChange={(event, newValue) => {
            params.api.setEditCellValue({
              id: params.id,
              field: params.field,
              value: newValue,
            });
          }}
          disableCloseOnSelect
          renderOption={(props, option: any, { selected }) => (
            <li {...props}>
              <Checkbox
                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                checkedIcon={<CheckBoxIcon fontSize="small" />}
                style={{ marginRight: 8 }}
                checked={selected}
              />
              {option?.name}
            </li>
          )}
          fullWidth
          renderTags={(value, getTagProps) =>
            value.map((option: any, index) => (
              <React.Fragment key={option.id || index}>
                <Chip
                  variant="outlined"
                  label={option?.name}
                  {...getTagProps({ index })}
                  sx={{ marginBottom: "4px" }}
                />
              </React.Fragment>
            ))
          }
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              multiline
              InputProps={{
                ...params.InputProps,
                style: {
                  paddingTop: 8,
                  paddingBottom: 8,
                  maxHeight: 150,
                  overflowY: "auto",
                },
              }}
            />
          )}
        />
      ),
    },

    {
      field: "teamMembers",
      headerName: "Team Members",
      width: 160,
      sortable: true,
      filterable: true,
      editable: false,
      renderEditCell: (params) => (
        <Autocomplete
          multiple
          options={CustomerList || []}
          getOptionLabel={(option) => option.name}
          value={
            CustomerList?.filter((cust: any) =>
              params?.row?.teamMembers
                ?.map((item: any) => item?._id)
                ?.includes(cust._id)
            )?.length || []
          }
          onChange={(event, newValue) => {
            params.api.setEditCellValue({
              id: params.id,
              field: params.field,
              value: newValue,
            });
          }}
          disableCloseOnSelect
          renderOption={(props, option: any, { selected }) => (
            <li {...props}>
              <Checkbox
                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                checkedIcon={<CheckBoxIcon fontSize="small" />}
                style={{ marginRight: 8 }}
                checked={selected}
              />
              {option?.name}
            </li>
          )}
          fullWidth
          renderTags={(value, getTagProps) =>
            value.map((option: any, index) => (
              <React.Fragment key={option.id || index}>
                <Chip
                  variant="outlined"
                  label={option?.name}
                  {...getTagProps({ index })}
                  sx={{ marginBottom: "4px" }}
                />
              </React.Fragment>
            ))
          }
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              multiline
              InputProps={{
                ...params.InputProps,
                style: {
                  paddingTop: 8,
                  paddingBottom: 8,
                  maxHeight: 150,
                  overflowY: "auto",
                },
              }}
            />
          )}
        />
      ),
    },

    {
      field: "status",
      type: "actions",
      headerName: "Status",
      width: 200,
      cellClassName: "actions",
      getActions: ({ id, row }) => {
        const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;
        if (!row?.ishideToggle) {
          return [<></>];
        }
        return [
          <Switch
            className="thinSwitch"
            checked={!row.isDeleted}
            onClick={handleDeleteClick(id, row)}
            sx={{
              "& .MuiSwitch-switchBase.Mui-checked": {
                color: "green",
                "& + .MuiSwitch-track": {
                  backgroundColor: "green",
                },
              },
              "& .MuiSwitch-switchBase": {
                color: "red",
                "& + .MuiSwitch-track": {
                  backgroundColor: "red",
                },
              },
            }}
          />
        ];
      },
    },

    {
      field: "actions",
      type: "actions",
      headerName: "Actions",

      ...(isBigScreen
        ? { flex: 1, width: 130 }
        : { flex: 0 }),

      cellClassName: "actions",
      getActions: ({ id, row }) => {

        if (!row?.ishideToggle) {
          return [<></>];
        }
        return [
          <GridActionsCellItem
            icon={<EditIcon />}
            key={`edit-${id}`}
            label="Edit"
            disabled={row.isDeleted}
            className="iconMilestone_edit"
            onClick={() => { handleEditClick(id); setIsOpen(true), setUserId(id) }}
            color="inherit"
          />,
        ];
      },
    },


  ];


  const filteredRows = rows.filter((row: any) => {
    const search = searchQuery.toLowerCase();

    const teamLeaderNames =
      row?.teamLeaders
        ?.map((leader: any) => leader?.name || "")
        .join(" ")
        .toLowerCase() || "";

    const teamMembersCount = (row?.teamMembers?.length) || 0;

    return (
      row?.teamName?.toLowerCase().includes(search) ||
      row?.description?.toLowerCase().includes(search) ||
      teamLeaderNames?.includes(search) ||
      teamMembersCount.toString()?.includes(search)
    );
  });
  return (
    <>
      <div className="old_dashboard_title">
        <h1 className="text-2xl font-bold text-gray-700 ">
          Manage Teams
        </h1>
      </div>
      <div className="whiteBox manageTeamsMain">
        <div className="flex flex-wrap items-center justify-between gap-4 mb-4">
          <SearchInput
            placeholder="Search"
            onChange={setSearchQuery}
            width={400}
          />

          <div>
            <Button
              className={clsx(
                "btnTheme whitespace-nowrap",
                {
                  "opacity-50 cursor-not-allowed": isAddDisabled,
                }
              )}
              onClick={() => setIsOpen(true)}
            >
              + Create New Team
            </Button>
          </div>
        </div>

        <Box
          sx={{
            height: gridHeight,
            boxShadow: "0 1px 2px rgba(0, 0, 0, .06), 0 2px 8px rgba(0, 0, 0, .05)",
            width: "100%",
            "& .actions": {
              color: "text.secondary",
            },
            "& .textPrimary": {
              color: "text.primary",
            },
            "& .new-row-border": {
              textAlign: "center",
            },
          }}
        >

          <DataGrid
            rows={filteredRows.map((row: any, index: any) => ({
              ...row,
              key: row?._id || row.id,
              id: row?._id || row.id,
              teamName: row?.teamName,
              description: row?.description,
              teamMembers: row?.teamMembers?.length || 0,
              teamLeaders: row?.teamLeaders,
              isDeleted: row?.isDeleted,
              s_no: index + 1,
            }))}
            columns={columns}
            loading={loading}
            getRowHeight={() => "auto"}
            getEstimatedRowHeight={() => 52}
            editMode="row"
            rowModesModel={rowModesModel}
            onRowModesModelChange={handleRowModesModelChange}
            onRowEditStop={handleRowEditStop}
            processRowUpdate={processRowUpdate}
            onPaginationModelChange={handlePaginationChange}
            initialState={{
              pagination: { paginationModel: { pageSize: 10, page: 0 } },
            }}
            pageSizeOptions={[10]}
            getRowClassName={(params) =>
              params.row.isNew ? "new-row-border" : ""
            }
            getRowId={(rows) => rows.id}
            slots={{
              toolbar: EditToolbar as GridSlots["toolbar"],
              loadingOverlay: CustomLoadingOverlay,
              noRowsOverlay: CustomNoRowsOverlay,
            }}
            slotProps={{
              toolbar: {
                setRows,
                setRowModesModel,
                currentPage,
                isAddDisabled,
                setIsAddDisabled,
              } as GridToolbarProps,
              loadingOverlay: { message: "Loading teams..." },
              noRowsOverlay: { message: "No teams found" },
            }}
            sx={{
              // Keeps the loading spinner / "No rows" message from collapsing
              // into a tiny sliver when there's no row data to size against.
              "--DataGrid-overlayHeight": "330px",
              "& .MuiDataGrid-cell": {
                display: "flex",
                alignItems: "center",
              },
              "& .MuiDataGrid-row": {
                borderBottom: "1px solid rgba(224, 224, 224, 1)",
              },

            }}

            autoHeight={false}
            rowHeight={38}
            columnHeaderHeight={42}
          />

        </Box>
      </div>
    </>
  );
}